document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.hc-mobile-toggle');
  var panel = document.getElementById('hc-mobile-nav');
  if (!toggle || !panel) return;

  toggle.addEventListener('click', function () {
    var isOpen = panel.classList.toggle('is-open');
    panel.hidden = !isOpen;
    toggle.setAttribute('aria-expanded', isOpen);
  });

  // Update cart count bubble live if theme dispatches cart updates
  document.addEventListener('cart:updated', function (e) {
    var countEl = document.querySelector('[data-cart-count]');
    if (countEl && e.detail && typeof e.detail.item_count !== 'undefined') {
      countEl.textContent = e.detail.item_count;
    }
  });

  // Force each dropdown to sit directly under its own nav item.
  // This guards against theme CSS overriding position/left on the <li>.
  var dropdownItems = document.querySelectorAll('.hc-nav__item.has-dropdown');
  dropdownItems.forEach(function (item) {
    var dropdown = item.querySelector('.hc-dropdown');
    if (!dropdown) return;

    function align() {
      var itemRect = item.getBoundingClientRect();
      dropdown.style.position = 'fixed';
      dropdown.style.top = itemRect.bottom + 'px';
      dropdown.style.left = itemRect.left + 'px';
    }

    item.addEventListener('mouseenter', align);
    item.addEventListener('focusin', align);
    window.addEventListener('resize', function () {
      if (getComputedStyle(dropdown).display !== 'none') align();
    });
  });
});